<template>
    <div class="orderby-ctn">
        <span class="orderby-text">排序：</span>
        <ul class="car-orderby">
            <li class="orderby-item"
                :class="{
                    'active': !active
                }"
                @click="doSelect(false)">
                <a class="order_item order_active" id="sortCreate">默认</a>
            </li>
            <li class="orderby-item"
                :class="{
                    'active': active === 'licensePlateDate',
                    'asc': licensePlateDateAsc,
                    'desc': !licensePlateDateAsc
                }"
                @click="doSelect('licensePlateDate')"
                @mouseover="hoverLicensePlateDate = true"
                @mouseleave="hoverLicensePlateDate = false">
                <a class="order_item" :title="licensePlateDateAsc? '上牌时间从远到近排序': '上牌时间从近到远排序'">
                    上牌时间
                    <span class="order-arrow"></span>
                </a>
            </li>
            <li class="orderby-item"
                :class="{
                    'active': active === 'price',
                    'asc': priceAsc,
                    'desc': !priceAsc
                }"
                @click="doSelect('price')"
                @mouseover="hoverPrice = true"
                @mouseleave="hoverPrice = false">
                <a class="order_item" :title="priceAsc? '价格从低到高排序': '价格从高到低排序'">
                    价格
                    <span class="order-arrow"></span>
                </a>
            </li> 
            <li class="orderby-item"
                :class="{
                    'active': active === 'mile',
                    'asc': mileAsc,
                    'desc': !mileAsc
                }"
                @click="doSelect('mile')"
                @mouseover="hoverMile = true"
                @mouseleave="hoverMile = false">
                <a class="order_item" :title="mileAsc? '里程数从低到高排序': '里程数从高到低排序'">
                    里程<span class="order-arrow"></span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                key: 'sortName',
                active: locationObj.search.get('sortName'),
                sortTypeAsc: locationObj.search.get('sortType') === 'asc',
                hoverLicensePlateDate: false,
                hoverPrice: false,
                hoverMile: false
            };
        },
        computed: {
            licensePlateDateAsc() {
                if (this.active === 'licensePlateDate') {
                    return this.sortTypeAsc ^ this.hoverLicensePlateDate;
                }
                return false ^ this.hoverLicensePlateDate;
            },
            priceAsc() {
                if (this.active === 'price') {
                    return this.sortTypeAsc ^ this.hoverPrice;
                }
                return false ^ this.hoverPrice;
            },
            mileAsc() {
                if (this.active === 'mile') {
                    return this.sortTypeAsc ^ this.hoverMile;
                }
                return false ^ this.hoverMile;
            }
        },
        methods: {
            doSelect(value) {
                if (value === this.active) {
                    this.sortTypeAsc = !this.sortTypeAsc;
                } else {
                    this.sortTypeAsc = true;
                }
                if (value) {
                    locationObj
                        .s(this.key, value)
                        .s('sortType', this.sortTypeAsc ? 'asc' : 'desc')
                        .s('index', null)
                        .go();
                } else {
                    locationObj
                        .s(this.key, null)
                        .s('sortType', null)
                        .s('index', null)
                        .go();
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// OrderbyCtn.vue?ff0ac322